import { Button, Col, Form, Input, Row, Typography, notification } from 'antd'
import React, { useState, useEffect } from 'react'
import { BUTTON, TEXT } from '../../../layout/style';
import { useNavigate, useLocation } from 'react-router-dom';
import validateForm from '../../../utils/FormValidation';
import validationRules from '../../../assets/validation/rules';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';
import { decodeToken } from "react-jwt";
import { useSelector } from 'react-redux';
const { Text } = Typography;

export default function ChangePassword() {
    const {token, companyId} = useSelector(state => state.auth);
    const location = useLocation();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [inputs, setInputs] = useState({
        password: '',
        confirmPassword: '',
    });
    const [errors, setErrors] = useState({});
    const [urlToken, setURLToken] = useState();
    const [decodedTokenValues, setDecodedTokenValues] = useState({});
    const [isFirstTime, setIsFirstTime] = useState(false);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {        
        if (location?.state?.token) {            
            const { token } = location.state;
            setURLToken(token);
            const decodedTokenValues = decodeToken(token);
            
            setDecodedTokenValues(decodedTokenValues);
            if(decodedTokenValues){    
                setIsExpired(decodedTokenValues?.isPasswordExpired)
                setIsFirstTime(decodedTokenValues?.isFirstTime)
            }   
            
            // clear the history
            navigate(location.pathname, {
                replace: true,
                state: null
            });
            
        } else if (window.location.href.includes("/changePassword/:tokenId?")) {
            const parts = window.location.href.split(":tokenId?");
            setURLToken(parts[1]);
            const decodedTokenValues = decodeToken(parts[1]);
            
            setDecodedTokenValues(decodedTokenValues);
            if(decodedTokenValues){    
                setIsExpired(decodedTokenValues?.isPasswordExpired)
                setIsFirstTime(decodedTokenValues?.isFirstTime)
            }            
        } else{
            setIsExpired(false)
            setIsFirstTime(false)
        }
    },[location.state, location.pathname, navigate]);

    function hasSequentialChars(value) {
        for (let i = 0; i < value.length - 2; i++) {
            const first = value.charCodeAt(i);
            const second = value.charCodeAt(i + 1);
            const third = value.charCodeAt(i + 2);
            if (second === first + 1 && third === second + 1) {
                return true;
            }
            else  if (second === first - 1 && third === second - 1) {
                return true;
            }
        }
        return false;
    }
    
    const fieldValidator = (fieldName) => (_, value) => {
        const errors = [];
        const displayFieldName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1)

        // Handle empty field
        if (!value) {
            errors.push(`${displayFieldName} is required.`);
        } else {
            // Password-specific validations
            if (fieldName === 'password') {
                // if (/(\w)\1{1,}/.test(value)) {
                //     errors.push(`${displayFieldName} cannot have more than 2 sequential characters.`);
                // }
                if (hasSequentialChars(value)) {
                    errors.push(`${displayFieldName} cannot have sequential characters like 'abc', '123', 'xyz'.`);
                }
                if (!/[A-Z]/.test(value)) {
                    errors.push(`${displayFieldName} must contain at least 1 uppercase character.`);
                }
                if (!/[a-z]/.test(value)) {
                    errors.push(`${displayFieldName} must contain at least 1 lowercase character.`);
                }
                if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
                    errors.push(`${displayFieldName} must contain at least 1 special character.`);
                }
                if (!/[0-9]/.test(value)) {
                    errors.push(`${displayFieldName} must contain at least 1 numeric character.`);
                }
                if (value.length < 8) {
                    errors.push(`${displayFieldName} must be at least 8 characters.`);
                }
                if (value.length > 32) {
                    errors.push(`${displayFieldName} cannot exceed 32 characters.`);
                }
            }
        }

        // Reject with line breaks (displayed correctly by AntD)
        return errors.length
            ? Promise.reject(new Error(errors.join('\n')))
            : Promise.resolve();
    };

    const confirmPasswordValidator = (_, value) => {
        const password = form.getFieldValue('password');
        if (!value) {
            return Promise.reject(new Error("Confirm Password is required."));
        }
        if (value !== password) {
            return Promise.reject(new Error("Passwords do not match."));
        }
        return Promise.resolve();
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            const {password, confirmPassword} = values;

            if (decodedTokenValues) {
                // First-time login user from login screen
                // Password expired user from login screen
                const payload = {
                    newPassword: password
                };

                AuthRestAPI.passwordChangeFromLogin(payload, companyId, urlToken)
                .then((res) => {
                    openNotificationWithIcon('success', 'Password reset!', `${res.message}`, 'topRight');
                    setTimeout(() => navigate("/login"), 1500);
                })
                .catch((err) => {
                    console.log('error ', errors)
                    const msg = err.response?.data?.message || err.message;
                    openNotificationWithIcon('error', 'Error', msg, 'topRight');
                });
            } else {
                // Forgot password -> change password
                const payload = {
                    token: urlToken,
                    newPassword: confirmPassword
                };

                AuthRestAPI.resetPwd(payload)
                    .then((res) => {
                        openNotificationWithIcon('success', 'Password reset!', `${res.message}`, 'topRight');
                        setTimeout(() => navigate("/login"), 1500);
                    })
                    .catch((err) => {
                        const msg = err.response?.data?.message || err.message;
                        openNotificationWithIcon('error', 'Error', msg, 'topRight');
                    });
            }
        } catch (error) {
            console.log('error in change password :', error);
        }
    }


    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    return (
        <div>
            <Row>
                <Col>
                    <h1 style={TEXT.heading1}>Change Password </h1>
                    <br />
                    <Text type='secondary'>
                        Please enter a new password that has not been used previously and confirm it below. <br /> The password must be at least 8 characters long.
                        {/* Amet ullamco exercitation pariatur duis veniam enim nisi id exercitation nostrud laborum amet. <br /> Dolor voluptate commodo do dolor ad ullamco esse sint culpa consequat. Aute dolor minim irure consectetur. */}
                    </Text>
                    <br />
                    <br />
                </Col>
            </Row>
            <Row>
                <Col xs={{
                    span: 20,
                }}
                    md={{
                        span: 18,
                    }}
                    lg={{
                        span: 16,
                    }}>
                    <Form name="basic" form={form}>
                        <Form.Item
                            // label="password"
                            name="password"
                            rules={[{validator: fieldValidator("password")}]}
                            style={{whiteSpace: 'pre-line'}}
                        >
                            <Input.Password
                                placeholder='Password'
                                autoComplete='off'
                                readOnly
                                onFocus={(e) => e.target.removeAttribute('readonly')}
                            />
                        </Form.Item>
                        <Form.Item
                            name="confirmPassword"
                            dependencies={['password']}
                            rules={[{ validator: confirmPasswordValidator }]}
                            style={{ whiteSpace: 'pre-line' }}
                            >
                            <Input.Password
                                // size="large"
                                placeholder="Confirm Password"
                                autoComplete="new-password"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" style={BUTTON.primary} onClick={handleSubmit}>Reset Password</Button>
                        </Form.Item>
                        {/* <Divider /> */}
                        {/* Go back? <Button type='link' onClick={()=>navigate("/login")}>Login</Button> */}
                    </Form>
                </Col>
            </Row>
            <Row>
                {contextHolder}
            </Row>
        </div>
    )
}